import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AppMode = 'sender' | 'driver';

interface AppState {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
}

/** Faqat UI afzalliklari. Server ma'lumotlari (profil, til) TanStack Query'da. */
export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      mode: 'sender',
      setMode: (mode) => set({ mode }),
    }),
    { name: 'posilka-app', version: 1, migrate: () => ({ mode: 'sender' }) as AppState },
  ),
);
